export const setBreadCrumbStack = (navigationElement) => ({
    type: 'SetBreadCrumbStack',
    payload: navigationElement
})

export const pushBreadcrumbItemToStack = (navigationElement) => ({
    type: 'PushBreadcrumbItemToStack',
    payload: navigationElement
})